/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewliveopenevent3Inputs */

const en_overviewliveopenevent3 = /** @type {(inputs: Overviewliveopenevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the event`)
};

const de_overviewliveopenevent3 = /** @type {(inputs: Overviewliveopenevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Event`)
};

/**
* | output |
* | --- |
* | "Open the event" |
*
* @param {Overviewliveopenevent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewliveopenevent3 = /** @type {((inputs?: Overviewliveopenevent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewliveopenevent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewliveopenevent3(inputs)
	return de_overviewliveopenevent3(inputs)
});
export { overviewliveopenevent3 as "overviewLiveOpenEvent" }